import FirendBaseItem from "./friend_base_item";
import { friend_utils } from "../friend_utils";
import EventManager from "../../../../../manager/event_manager";
import LanguageManager from "../../../../../manager/language_manager";
import ModuleManager from "../../../../../framework/core/module_manager";
import TimeManager from "../../../../../manager/time_manager";
import Utility from "../../../../../utility/utility";
import PlayerIconModule from "../../playericon/playerIcon";
import GameUtil from "../../../../../utility/game_util";
import ModelData from "../../../../public/model_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class FriendListItem extends FirendBaseItem {


    @property(cc.Button)
    giftBtn: cc.Button = null;

    @property(cc.Button)
    transferBtn: cc.Button = null;

    @property(cc.Node)
    offlineMask: cc.Node = null

    private markTime: number;

    private transferRemain: number;

    onLoad() {

    }

    updateInfo(data: any, currency?: number) {
        super.updateInfo(data, currency);

        this.offlineMask.active = !data.online;

        this.refreshGift();

    }

    updateRemain(remain: number) {

        this.transferRemain = remain;
        //this.transferBtn.interactable = remain > 0
        this.setGray(remain <= 0, this.transferBtn);
    }

    updateCurrency(currency) {
        this.currency = currency;

        this.refreshGift();
    }

    private refreshGift() {

        let self = this;

        friend_utils.isAllowHandsel(this.currency, this.friendId, (result) => {
            if (self.isValid) {
                self.setGray(!result, self.giftBtn);
            }
        });
    }

    private setGray(state: boolean, button: cc.Button) {
        // button.enabled = !state
        let bg = button.node.getChildByName("Background")
        let grey = button.node.getChildByName("GreyBackground")
        bg.active = !state
        grey.active = state
        // if (state) {

        //     button.normalColor = new cc.Color(200, 200, 200, 255);
        //     button.hoverColor = new cc.Color(200, 200, 200, 255);
        //     button.pressedColor = new cc.Color(200, 200, 200, 255);
        //     button.disabledColor = new cc.Color(200, 200, 200, 255);

        // } else {

        //     button.normalColor = new cc.Color(255, 255, 255, 255);
        //     button.hoverColor = new cc.Color(255, 255, 255, 255);
        //     button.pressedColor = new cc.Color(255, 255, 255, 255);
        //     button.disabledColor = new cc.Color(255, 255, 255, 255);
        // }
    }


    onChat() {

        this.eventDispatch("request_chat_friend");

        Utility.playButtonSound()
    }

    onGift() {

        Utility.playButtonSound()

        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.markTime > 0 && this.markTime + 1 > AppRunningTime) {
            ModuleManager.instance.toast("สนทนานี้บ่อยเกินไป  โปรดหยุดพักก่อนค่ะ")
            return
        }
        this.markTime = AppRunningTime

        let self = this;
        friend_utils.reqHandsel(this.friendId, (result) => {
            if (result) {
                self.currency -= friend_utils.handselNum;
                self.refreshGift();
                ModuleManager.instance.toast(LanguageManager.t("friend_git_success"));
                EventManager.instance.dispatch("friend_list_do_action");
            }
        })
    }

    onTransfer() {
        Utility.playButtonSound()

        if (this.transferRemain <= 0) {
            //转账金额不足                                   
            friend_utils.showTransferTip();
        }
        else {

            this.eventDispatch("request_transfer_friend");
        }

    }

    onItem() {

        Utility.playButtonSound()
        ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule, { userId: this.friendId, other: true })
    }


}
